import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../adminApi';
import { CatalogProductFormState, createCatalogProductCreatePayload, createCatalogProductUpdatePayload } from './catalogFormValues';

export function useCatalogProductQuery(entityId?: number) {
  return useQuery({
    queryKey: ['catalog', 'product', entityId],
    enabled: entityId !== undefined,
    queryFn: async () => {
      const result = await adminApi.getCatalogProducts({ product_id: entityId, page: 1, per_page: 1 });
      const entity = result.items.find((item) => item.product_id === entityId);
      if (!entity) throw new Error('Товар не найден.');
      return entity;
    },
  });
}

export function useCatalogProductSave(entityId?: number) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (values: CatalogProductFormState) => {
      if (entityId === undefined) {
        const payload = createCatalogProductCreatePayload(values);
        return adminApi.createCatalogProduct(payload);
      }
      const payload = createCatalogProductUpdatePayload(values);
      return adminApi.updateCatalogProduct(entityId, payload);
    },
    onSuccess: () => client.invalidateQueries({ queryKey: ['catalog'] }),
  });
}
